// İşlem Logları penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'accounts.transactionLogs';

export const accountTransactionLogsGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'İşlem Logları nasıl okunur?'),
  intro: t(`${G}.intro`, 'Bu kayıtlar cari hareketlerde yapılan önemli değişiklikleri geçmişe dönük izleyebilmeniz için tutulur.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'İşlem Logları'),
    table: t(`${G}.regions.table`, 'Log listesi'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Loglar ne için var?'),
      text: t(`${G}.s1.text`, 'İşlem silme veya ödeme yöntemi değiştirme gibi önemli değişiklikler denetim amacıyla saklanır: değişikliğin türü, eski / yeni değer ve değişiklik nedeni. Böylece kimin neyi ne zaman değiştirdiğini sonradan görebilirsiniz.'),
    },
    {
      region: 'table',
      title: t(`${G}.s2.title`, '2. Satırları okuyun'),
      text: t(`${G}.s2.text`, 'Her satırda tarih, işlem numarası (Transaction ID), değişikliğin türü, eski ve yeni değer, değişiklik nedeni ve işlemi yapan kişi yer alır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Tür etiketi renklidir: İşlem Oluşturuldu yeşil, Ödeme Yöntemi Değişti turuncu, İşlem Silindi kırmızı.'),
        t(`${G}.s2.tip2`, 'Kayıtlar en yeniden en eskiye doğru sıralanır.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s3.title`, '3. Sayfalar arasında gezin'),
      text: t(`${G}.s3.text`, 'Alttaki sayfalama ile eski kayıtlara ilerleyin ve sayfa başına kaç satır görüneceğini seçin.'),
    },
  ],
});
